import { CompanyRequestError, companyRequest } from '@/company/api';

// The action routes an Agent request is decided through (the same ones Chat's cards use):
// GET /api/v1/actions/:id, POST …/presented, …/approve and …/reject. The server owns who
// may decide, what "Don't ask again" remembers and whether the request is still waiting.

export interface AgentRequestConnection {
  name?: string;
  title?: string;
  /** Display labels for the call's argument names. */
  fields?: Record<string, string>;
  isRead?: boolean;
}
export type AgentRequestHeld = 'ask' | 'floor' | 'email_send' | 'unknown_risk';
export interface AgentRequestOutside {
  grantId?: string;
  agentName?: string;
  family?: string;
  mode?: string;
  held?: AgentRequestHeld | string;
  key?: { connectionId?: string; action?: string };
  allowAgain?: { offered: boolean; label: string | null };
}
export interface AgentRequestAction {
  id: string;
  tool: string;
  label: string;
  args: Record<string, unknown> | null;
  digest: string;
  status: string;
  canDecide: boolean;
  decision?: { connection?: AgentRequestConnection } | null;
  outside?: AgentRequestOutside | null;
}

const path = (id: string, tail = '') => `/api/v1/actions/${encodeURIComponent(id)}${tail}`;

export const agentRequestApi = {
  get: async (id: string) =>
    (await companyRequest<{ action: AgentRequestAction }>(path(id))).action,
  presented: (id: string, digest: string) =>
    companyRequest<{ cardToken?: string; cardTokenExpiresAt?: string }>(
      path(id, '/presented'),
      'POST',
      { digest },
    ),
  approve: (id: string, input: { digest: string; cardToken: string; dontAskAgain: boolean }) =>
    companyRequest<{ action: AgentRequestAction }>(path(id, '/approve'), 'POST', input),
  reject: (id: string, digest: string) =>
    companyRequest<{ action: AgentRequestAction }>(path(id, '/reject'), 'POST', { digest }),
};

/** The server's refusal code, whatever the message says. */
export const requestErrorCode = (error: unknown) =>
  error instanceof CompanyRequestError ? error.code : null;
